/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { connect } from 'react-redux';

import { convertQueryStringToKeyValuePairs } from 'Util/Url';
import { ConfirmAccountPageContainer as SourceConfirmAccountPageContainer, mapStateToProps, mapDispatchToProps } from 'SourceRoute/ConfirmAccountPage/ConfirmAccountPage.container';

/** @namespace Route/ConfirmAccountPage/Container */
export class ConfirmAccountPageContainer extends SourceConfirmAccountPageContainer {
    containerProps() {
        const { redirect, isLoading } = this.state;
        const {
            location: {
                search
            }
        } = this.props;

        const { email } = convertQueryStringToKeyValuePairs(search);

        return {
            redirect,
            isLoading,
            shouldDisplayWarning: this.shouldDisplayWarning(),
            email
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAccountPageContainer);
